export const ENVIRONMENT = {
    version : import.meta.env.VITE_APP_VERSION as string,
    domainApi : import.meta.env.VITE_DOMAIN_API,
    oneplace : import.meta.env.VITE_ONEPLACE,
    buildVersion : import.meta.env.VITE_VERSION,
    enableDarkMode: import.meta.env.VITE_ENABLE_DARK_MODE === 'true',
  authApiPath: {
    basePath: import.meta.env.VITE_AUTH_API,
    client: {
      getClientDatabaseName:
        import.meta.env.VITE_AUTH_API + `/client/GetClientDatabaseName`,
    },
    region: {
      allRegions: import.meta.env.VITE_AUTH_API + `/region/GetAllRegions`,
      regions: import.meta.env.VITE_AUTH_API + `/region`,
    },
    logs: {
      GetLogsByCorrelationId:
        import.meta.env.VITE_AUTH_API + `/logs/GetLogsByCorrelationId`,
    },
    user: {
      allUsers: import.meta.env.VITE_AUTH_API + `/user/GetAllUsers`,
      getEmployers: import.meta.env.VITE_AUTH_API + `/user/GetEmployers`,
      getUserClaims: import.meta.env.VITE_AUTH_API + `/user/GetUserClaims`,
      generateUserToken:
        import.meta.env.VITE_AUTH_API + `/user/GenerateUserToken`,
      getIntegrationSystems:
        import.meta.env.VITE_AUTH_API + `/user/GetIntegrationSystems`,
      getAddUsersModel:
        import.meta.env.VITE_AUTH_API + `/user/GetAddUsersModel`,
      getRemoveUsersModel:
        import.meta.env.VITE_AUTH_API + `/user/GetRemoveUsersModel`,
      processUserImportFile : import.meta.env.VITE_AUTH_API + `/user/ProcessUserImportFile`,
            removeUsers : import.meta.env.VITE_AUTH_API + `/user/RemoveUsers`,
            addUser : import.meta.env.VITE_AUTH_API + '/user/AddUser',
            userLogout : import.meta.env.VITE_AUTH_API + '/user/logout',
            userPreference : import.meta.env.VITE_AUTH_API + '/UserPreference',
        },
        widget : {
            getWidgets : import.meta.env.VITE_AUTH_API + `/widget/GetWidgets`,
        },
    },
};
